import { NgModule } from '@angular/core';
import { AirQuoteResourceService } from './airQuoteResource.service';
import { ResourceModule } from "../../resource/resource.module";
import { AirQuoteMappingService } from "./air-quote-mapping.service";

@NgModule({
    imports:      [
        ResourceModule,
    ],
    providers: [
        AirQuoteResourceService,
        AirQuoteMappingService,
    ],
})
export class AirQuoteResourceModule {  }
